module.exports = __webpack_public_path__ + "media/images/version_merge/technical_error-5ebf5ed0371066001aa3c1b9fc5cf8aa.png";